const SprintTypes = {
    ADD_SPRINT: ' ADD_SPRINT',
     ADD_SPRINT_LOADING: ' ADD_SPRINT_LOADING',
     ADD_SPRINT_SUCCESS: ' ADD_SPRINT_SUCCESS',
     ADD_SPRINT_ERROR: ' ADD_SPRINT_ERROR',
     ADD_SPRINT_RESET: ' ADD_SPRINT_RESET',

     GET_ALL_SPRINT: ' GET_ALL_SPRINT',
     GET_ALL_SPRINT_LOADING: ' GET_ALL_SPRINT_LOADING',
     GET_ALL_SPRINT_SUCCESS: ' GET_ALL_SPRINT_SUCCESS',
     GET_ALL_SPRINT_ERROR: ' GET_ALL_SPRINT_ERROR',
     GET_ALL_SPRINT_RESET: ' GET_ALL_SPRINT_RESET',
//start single sprint ----------------------
     GET_ALL_SINGLE_SPRINT: ' GET_ALL_SINGLE_SPRINT',
     GET_ALL_SINGLE_SPRINT_LOADING: ' GET_ALL_SINGLE_SPRINT_LOADING',
     GET_ALL_SINGLE_SPRINT_SUCCESS: ' GET_ALL_SINGLE_SPRINT_SUCCESS',
     GET_ALL_SINGLE_SPRINT_ERROR: ' GET_ALL_SINGLE_SPRINT_ERROR',
     GET_ALL_SINGLE_SPRINT_RESET: ' GET_ALL_SINGLE_SPRINT_RESET',

     GET_SPRINT_FOR_TASK: ' GET_SPRINT_FOR_TASK',
     GET_SPRINT_FOR_TASK_LOADING: ' GET_SPRINT_FOR_TASK_LOADING',
     GET_SPRINT_FOR_TASK_SUCCESS: ' GET_SPRINT_FOR_TASK_SUCCESS',
     GET_SPRINT_FOR_TASK_ERROR: ' GET_SPRINT_FOR_TASK_ERROR',
     GET_SPRINT_FOR_TASK_RESET: ' GET_SPRINT_FOR_TASK_RESET',
//end single sprint ----------------------

    DELETE_SPRINT: 'DELETE_SPRINT',
    DELETE_SPRINT_LOADING: 'DELETE_SPRINT_LOADING',
    DELETE_SPRINT_SUCCESS: 'DELETE_SPRINT_SUCCESS',
    DELETE_SPRINT_ERROR: 'DELETE_SPRINT_ERROR',
    DELETE_SPRINT_RESET: 'DELETE_SPRINT_RESET',

    GET_SPRINT_BY_ID: ' GET_SPRINT_BY_ID',
     GET_SPRINT_BY_ID_LOADING: ' GET_SPRINT_BY_ID_LOADING',
     GET_SPRINT_BY_ID_SUCCESS: ' GET_SPRINT_BY_ID_SUCCESS',
     GET_SPRINT_BY_ID_ERROR: ' GET_SPRINT_BY_ID_ERROR',
     GET_SPRINT_BY_ID_RESET: ' GET_SPRINT_BY_ID_RESET',

     UPDATE_SPRINT: 'UPDATE_SPRINT',
     UPDATE_SPRINT_LOADING: 'UPDATE_SPRINT_LOADING',
     UPDATE_SPRINT_SUCCESS: 'UPDATE_SPRINT_SUCCESS',
     UPDATE_SPRINT_ERROR: 'UPDATE_SPRINT_ERROR',
     UPDATE_SPRINT_RESET: 'UPDATE_SPRINT_RESET',
  
}
export default SprintTypes;